// BookTickets/stages/DateAndTime/hooks/usePersistedSelectedDate.ts
'use client'

import { useBookingActionsCtx, useBookingState } from '../../../state/booking.context'

type UsePersistedSelectedDateResult = {
  selectedDate: Date
  setSelectedDate: (d: Date) => void
  initialised: boolean
}

/**
 * Thin wrapper over the booking context's calendarDate. Resolution (?date= /
 * sessionStorage / session lookup / manual pick) and precedence between those
 * sources both live in booking.context.tsx and booking.reducer.ts.
 */
export function usePersistedSelectedDate(): UsePersistedSelectedDateResult {
  const { calendarDate, calendarDateInitialised } = useBookingState()
  const { dispatch } = useBookingActionsCtx()

  const setSelectedDate = (d: Date) => {
    dispatch({ type: 'SET_CALENDAR_DATE', calendarDate: d, source: 'user' })
  }

  return {
    selectedDate: calendarDate ?? new Date(),
    setSelectedDate,
    initialised: calendarDateInitialised,
  }
}
